import { render } from "./PostDetails.vue?vue&type=template&id=7a0b8b7b&scoped=true"
import script from "./PostDetails.vue?vue&type=script&lang=js"
export * from "./PostDetails.vue?vue&type=script&lang=js"

import "./PostDetails.vue?vue&type=style&index=0&id=7a0b8b7b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a0b8b7b"]])

export default __exports__